
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPurchaseConfirmation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchase"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CO_PurchaseInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CO_SendPurchaseConfirmation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"purchase"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchase"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseBase"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseStatus"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseCancellations"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseStatusLogs"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseCheckboxes"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchasePurchaser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseItems"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseConfirmations"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseInvoices"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseReceipts"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseSoldCoupons"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseCoupons"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseDetailedSummary"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseSeller"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchasePointOfSale"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseCashFlowLogs"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PurchaseShippingPackages"},"directives":[]}]}}]}}],"loc":{"start":0,"end":670}};
    doc.loc.source = {"body":"#import \"../fragments/Purchase.gql\"\n\nmutation SendPurchaseConfirmation($purchase: CO_PurchaseInput!) {\n    CO_SendPurchaseConfirmation(purchase: $purchase) {\n        ...PurchaseBase\n        ...PurchaseStatus\n        ...PurchaseCancellations\n        ...PurchaseStatusLogs\n        ...PurchaseCheckboxes\n        ...PurchasePurchaser\n        ...PurchaseItems\n        ...PurchaseConfirmations\n        ...PurchaseInvoices\n        ...PurchaseReceipts\n        ...PurchaseSoldCoupons\n        ...PurchaseCoupons\n        ...PurchaseDetailedSummary\n        ...PurchaseSeller\n        ...PurchasePointOfSale\n        ...PurchaseCashFlowLogs\n        ...PurchaseShippingPackages\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/Purchase.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SendPurchaseConfirmation"] = oneQuery(doc, "SendPurchaseConfirmation");
        
